import React, { useState } from 'react'
import { useQueryParams } from 'raviger'

import request from 'Request'
import { downloadText, sanitizeObject } from 'Helpers'

import CardButton from 'Components/CardButton'
import { Flex } from 'lese'
import Section from 'Components/Section'
import Header from 'Components/Header'
import DateSelector from 'Components/DateSelector'

import { faPrint, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import config from 'Config'

export default ({ title, csvUrl, csvPayload, appCode }) => {
  const [{ startDate, endDate, ...query }, setQuery] = useQueryParams()
  const [dates, setDates] = useState({ startDate, endDate })
  return (
    <>
      <Flex xAlign="space-between">
        <Header>{title}</Header>
        <Flex separation="8px" yAlign="stretch">
          <CardButton
            onClick={() =>
              request(`${config.api.getUrl()}${csvUrl}`, {
                method: 'POST',
                params: { appCode, startDate, endDate, ...query },
                data:
                  typeof csvPayload === 'function' ? csvPayload() : csvPayload
              }).then(response => {
                downloadText(
                  response.headers['content-disposition'].split('filename=')[1],
                  response.data
                )
              })
            }
          >
            <span>Download All</span>
            <FontAwesomeIcon icon={faDownload} size="2x" />
          </CardButton>
          <CardButton onClick={window.print.bind(window)}>
            <span>Print</span>
            <FontAwesomeIcon icon={faPrint} size="2x" />
          </CardButton>
          <DateSelector
            value={dates}
            onChange={setDates}
            onClose={dates => {
              setQuery({
                ...query,
                ...sanitizeObject({
                  startDate: dates?.startDate?.getTime(),
                  endDate: dates?.endDate?.getTime()
                })
              })
              location.reload()
            }}
          />
        </Flex>
      </Flex>
      {appCode && <Section header="App Code" title={appCode} />}
    </>
  )
}
